import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Language } from './shared/config/language';
import siteSettings from './shared/config/site-settings';
import { ActivatedRoute } from '@angular/router';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  styles: ['']
})
export class AppComponent implements OnInit, OnDestroy {
  private languageCheckInterval: Subscription;

  constructor(
    private translate: TranslateService,
    private route: ActivatedRoute
  ) {
    translate.setDefaultLang('kk');
    // Start checking for language changes
    this.startLanguageCheck();
  }

  ngOnInit(): void {
    // Get URL parameters
    this.route.queryParams.subscribe(params => {
      const accessToken = params['access_token'];
      const lang = params['lang'];

      // Always store access token from URL, even if it's 'null'
      // This is important for the sidebar to work properly
      localStorage.setItem('access_token', accessToken || '');

      // Set language from URL parameter
      if (lang) {
        this.setLanguageFromParam(lang);
        return;
      }

      // If no URL param, check localStorage from main site
      const mainSiteLang = localStorage.getItem('currentLang');
      if (mainSiteLang) {
        this.setLanguageFromMainSite(mainSiteLang);
        return;
      }

      // Fallback to map's own language setting
      this.setFallbackLanguage();
    });
  }

  ngOnDestroy(): void {
    if (this.languageCheckInterval) {
      this.languageCheckInterval.unsubscribe();
    }
  }

  private startLanguageCheck(): void {
    // Check for language changes every second
    this.languageCheckInterval = interval(1000).subscribe(() => {
      const mainSiteLang = localStorage.getItem('currentLang');
      if (mainSiteLang && mainSiteLang !== this.translate.currentLang) {
        this.setLanguageFromMainSite(mainSiteLang);
      }
    });
  }

  private setLanguageFromParam(lang: string): void {
    let language = Language.KAZ;
    let langCode = 'kk';

    if (lang === 'ru') {
      language = Language.RUS;
      langCode = 'ru';
    } else if (lang === 'en') {
      language = Language.ENG;
      langCode = 'en';
    }

    this.updateLanguageSettings(language, langCode);
  }

  private setLanguageFromMainSite(lang: string): void {
    let language = Language.KAZ;
    let langCode = 'kk';

    if (lang === 'ru') {
      language = Language.RUS;
      langCode = 'ru';
    } else if (lang === 'en') {
      language = Language.ENG;
      langCode = 'en';
    }

    this.updateLanguageSettings(language, langCode);
  }

  private setFallbackLanguage(): void {
    const storedLanguage = localStorage.getItem('eJambylLanguage');
    const language: number = storedLanguage ? JSON.parse(storedLanguage) : Language.KAZ;
    let langCode = 'kk';

    if (language === Language.KAZ) {
      langCode = 'kk';
    } else if (language === Language.RUS) {
      langCode = 'ru';
    } else if (language === Language.ENG) {
      langCode = 'en';
    }

    this.updateLanguageSettings(language, langCode);
  }

  private updateLanguageSettings(language: number, langCode: string): void {
    this.translate.use(langCode);
    siteSettings.language = language;
    localStorage.setItem('eJambylLanguage', JSON.stringify(language));
    localStorage.setItem('currentLang', langCode);
  }
}
